var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright-card"},[_c('el-row',{attrs:{"type":"flex","align":"bottom","justify":"space-between"}},[_c('el-col',{attrs:{"span":9}},[_c('copyrightInformation')],1),_c('el-col',{attrs:{"span":12}},[_c('img',{staticClass:"copyright-img",attrs:{"src":`${
          _vm.setting.backgroundImage2 || '@/assets/images/reserved-bg.png'
        }`}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }